import { useState, useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../../../utils/axios.js"; 
import { AuthContext } from "../../../context/authContext";
import upload from "../../../lib/uploadDatabase";

export const useUpdateProfile = (user, setOpenUpdate) => {
    const { currentUser, setCurrentUser } = useContext(AuthContext);
    const queryClient = useQueryClient();

    const [coverFile, setCoverFile] = useState(null);
    const [profileFile, setProfileFile] = useState(null);

    const [texts, setTexts] = useState({
        name: user.name || "",
        city: user.city || "",
        website: user.website || "",
        email: user.email || "",
        password: ""
    });

    const handleChange = (e) => {
        setTexts((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const mutation = useMutation({
        mutationFn: (userData) => makeRequest.put("/users", userData),
        onSuccess: (res, variables) => {
            const updatedUser = { ...currentUser, ...variables };
            setCurrentUser(updatedUser);
            
            queryClient.invalidateQueries({ queryKey: ["user"] });
            setOpenUpdate(false);
        },
        onError: (error) => {
            console.error("Error updating user:", error);
            alert("An error occurred during the update.");
        },
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        let coverUrl = user.coverPic;
        let profileUrl = user.profilePic;

        try {
            if (coverFile) {
                const imgUrl = await upload(coverFile);
                coverUrl = Array.isArray(imgUrl) ? imgUrl[0] : imgUrl;
            }

            if (profileFile) {
                const imgUrl = await upload(profileFile);
                profileUrl = Array.isArray(imgUrl) ? imgUrl[0] : imgUrl;
            }

            const updateData = {
                ...texts,
                coverPic: coverUrl,
                profilePic: profileUrl,
            };

            if (!updateData.password || updateData.password.trim() === "") {
                delete updateData.password;
            }

            mutation.mutate(updateData);

        } catch (err) {
            console.error("Upload failed:", err);
            alert("Error uploading image.");
        }
    };

    return {
        formState: { texts, coverFile, profileFile },
        actions: { 
            handleChange, 
            setCoverFile, 
            setProfileFile, 
            handleSubmit 
        },
        isUpdating: mutation.isPending
    };
};